// extracted by mini-css-extract-plugin
export var mainContainer = "sessionList-module--main-container--1qw9W";
export var mainContainerInPerson = "sessionList-module--main-container-in-person---fKIB";
export var sessionTime = "sessionList-module--session-time--QJatq";
export var eventDate = "sessionList-module--event-date--BrOyE";
export var sessionList = "sessionList-module--session-list--ZlM5e";
export var subContainer = "sessionList-module--sub-container--39bqY";
export var subContainerInPerson = "sessionList-module--sub-container-in-person--25zRz";
export var divisionOne = "sessionList-module--division-one--3w9mz";
export var divisionOneInPerson = "sessionList-module--division-one-in-person--ajYLi";
export var sessionTypeAndDate = "sessionList-module--session-type-and-date--4_YoA";
export var sessionType = "sessionList-module--session-type--2_pen";
export var sessionTimeInPerson = "sessionList-module--session-time-in-person--CzLPc";
export var sessionTypeInPerson = "sessionList-module--session-type-in-person--16SzV";
export var saveButton = "sessionList-module--save-button--2B3kD";
export var videoButton = "sessionList-module--video-button--1qHuy";
export var modal = "sessionList-module--modal--8ydJI";
export var moreButton = "sessionList-module--more-button--3DFzz";
export var saveButtonMobile = "sessionList-module--save-button-mobile--3d6vQ";
export var divisionTwo = "sessionList-module--division-two--Wor55";
export var divisionTwoInPerson = "sessionList-module--division-two-in-person--2wQo5";
export var sessionTitle = "sessionList-module--session-title--WH_H0";
export var venue = "sessionList-module--venue--1XixE";
export var venueInPerson = "sessionList-module--venue-in-person--pMF1I";
export var sessionSpeaker = "sessionList-module--session-speaker--39-S2";
export var sessionSpeakerInPerson = "sessionList-module--session-speaker-in-person--3F2xA";
export var jumpLink = "sessionList-module--jump-link--38tvQ";
export var speakerImageAvatar = "sessionList-module--speaker-image-avatar--1hTKE";
export var speakerImageAvatarInPerson = "sessionList-module--speaker-image-avatar-in-person--3SVsA";
export var speakerDetails = "sessionList-module--speaker-details--v4G-A";
export var speakerDetailsInPerson = "sessionList-module--speaker-details-in-person--HHZZ7";
export var speakerName = "sessionList-module--speaker-name--t0hG6";
export var speakerNameInPerson = "sessionList-module--speaker-name-in-person--_Y_pF";
export var speakerTitle = "sessionList-module--speaker-title--2-lwX";
export var speakerTitleInPerson = "sessionList-module--speaker-title-in-person--2U1IM";
export var headingContent = "sessionList-module--heading-content--WSJqb";
export var heading = "sessionList-module--heading--1wz9E";
export var whiteText = "sessionList-module--white-text--361nj";